import React, { useEffect, useState } from "react";
import { Box, Paper } from "@mui/material";
import Typography from "@mui/material/Typography";
import axios from "axios";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const Dashboard = () => {
  const [data, setData] = useState([
    {
      name: "Số Đơn hàng",
      value: 0,
    },
    {
      name: "Số Sản Phẩm",
      value: 0,
    },
    {
      name: "Số Bài Viết",
      value: 0,
    },
  ]);

  const [chartData, setChartData] = useState({});
  const [orderNonAccept, setOrderNonAccept] = useState(0);

  useEffect(() => {
    getDataOrder();
    getDataProducts();
    getDataPosts();
    getDataOrderWithStatus();
    getOrderThisWeek();
  }, []);

  const getDataOrder = () => {
    axios
      .get(`/api/v1/orders`, {
        params: {
          page: 1,
        },
      })
      .then((res) => {
        const updatedValue = res.data.totalItems;
        setData((prevData) =>
          prevData.map((item, index) =>
            index === 0 ? { ...item, value: updatedValue } : item
          )
        );
      })
      .catch((err) => console.log(err));
  };

  const getDataOrderWithStatus = () => {
    axios
      .get(`/api/v1/orders`, {
        params: {
          status: 0,
          page: 1,
        },
      })
      .then((res) => {
        setOrderNonAccept(res.data.totalItems);
      })
      .catch((err) => console.log(err));
  };

  const getDataProducts = () => {
    axios
      .get(`/api/v1/products`, {
        params: {
          page: 1,
        },
      })
      .then((res) => {
        const updatedValue = res.data.totalItems;
        setData((prevData) =>
          prevData.map((item, index) =>
            index === 1 ? { ...item, value: updatedValue } : item
          )
        );
      })
      .catch((err) => console.log(err));
  };

  const getDataPosts = () => {
    axios
      .get(`/api/v1/posts`, {
        params: {
          page: 1,
        },
      })
      .then((res) => {
        const updatedValue = res.data.totalItems;
        setData((prevData) =>
          prevData.map((item, index) =>
            index === 2 ? { ...item, value: updatedValue } : item
          )
        );
      })
      .catch((err) => console.log(err));
  };

  const getOrderThisWeek = () => {
    axios
      .get(`/api/v1/orders/get-this-week`)
      .then((res) => {
        setChartData(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <Box component="section" sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Chào mừng đến với trang quản lý
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          pt: 3,
        }}
      >
        {data.map((item, idx) => (
          <Paper
            key={idx}
            sx={{
              width: 300,
              height: 150,
              backgroundColor: "#0184b7",
              color: "#fff",
              fontWeight: "bold",
              fontSize: 28,
              p: "10px 20px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                zIndex: 1,
                position: "relative",
              }}
            >
              {item.name}
              {idx == 0 && (
                <Box sx={{ fontSize: 16, pt: 1 }}>
                  • Chưa xác nhận: {orderNonAccept}
                </Box>
              )}
            </Box>
            <Box
              sx={{
                fontSize: 52,
                textAlign: "end",
                position: "absolute",
                bottom: 10,
                right: 20,
                zIndex: 2,
              }}
            >
              {item.value}
            </Box>
          </Paper>
        ))}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "1200px", height: "600px", pt: 5 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip
                formatter={(value, name, props) => {
                  if (name === "countOrder") {
                    return [`Số lượng đơn hàng: ${value}`];
                  }
                  return [value];
                }}
                labelFormatter={(label) => {
                  if (label === "countOrder") {
                    return "";
                  }
                  return label;
                }}
              />
              <Legend />
              <Bar
                dataKey="countOrder"
                fill="#0184b7"
                name="Số lượng đơn hàng trong tuần"
                activeBar={<Rectangle fill="#0184b7" stroke="#0184b7" />}
              />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
